import {FilterPredicate} from 'src/hooks/filtered-data/filter-predicate';

export const BLANK = '(Blank)';

export class ArrayFilterPredicate<T> implements FilterPredicate<T> {

    // eslint-disable-next-line no-useless-constructor
    constructor(
        private readonly valueExtractor: (row: T) => string[],
        private readonly filterValue: string[],
    ) {
    }

    isActive(): boolean {
        return this.filterValue.length > 0;
    }

    check(row: T): boolean {
        const rowValue = this.valueExtractor(row);
        const matchesBlank = rowValue.length === 0 && this.filterValue.includes(BLANK);
        return this.filterValue.some(value => rowValue.includes(value) || matchesBlank);
    }
}
